// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__14qgK","modalForm":"UpgradeEpcsModal_modalForm__JlemS","modalFooter":"UpgradeEpcsModal_modalFooter__GwR--"};